export const API_URL = `https://kritydangol.com.np/api/portfolio.json`;
